import { useFormContext } from 'react-hook-form';

import { Checkbox, Box } from '@ui';
import { useTranslate } from '@i18n';

import { Input } from '../Input';

import * as css from './CoachProfileSection.css';

export const CoachProfileSection = () => {
    const { register } = useFormContext();
    const t = useTranslate();

    return (
        <div className={css.coachProfileSettings}>
            <div className={css.container}>
                <Input
                    label={t('user_settings.coach_location_label')}
                    placeholder={t('user_settings.coach_location_placeholder')}
                    {...register('coach.location')}
                />
                <Box display="flex" gap={8} flexWrap="wrap">
                    <div className={css.checkbox}>
                        <Checkbox label={t('user_settings.pga_certified')} {...register('coach.pgaCertified')} />
                    </div>
                    <div className={css.checkbox}>
                        <Checkbox label={t('user_settings.elva_certified')} {...register('coach.elvaCertified')} />
                    </div>
                </Box>
            </div>
        </div>
    );
};
